import { Component } from "react";

// -----------Importar Componentes de Terceros------------------
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { createTheme } from '@mui/material/styles';
import Slider from "react-slick";

import FAQ from '../../components/Acordion';

import './css/style.css'; // Importa el archivo de estilos CSS

import ImagenPreguntaF1 from '../../assets/Imagenes/Preguntas_Frecuentes/ImagenPF1.png'
import ImagenPreguntaF2 from '../../assets/Imagenes/Preguntas_Frecuentes/ImagenPF2.png'
import PreguntasAyuda from '../../assets/Imagenes/Preguntas_Frecuentes/slider/PreguntasAyuda.png'
import PreguntasAyudaMovil from '../../assets/Imagenes/Preguntas_Frecuentes/PreguntasAyudaMovil.png'



const faqItems1 = [
  {
    question: "¿Puedo contratar un servicio funerario completo desde la página web?",
    answer: "Sí. Columba te ofrece la organización de un servicio funerario integral sin tener que salir de tu hogar. Nos encargamos de todos los trámites y logística para tener una experiencia más sencilla y menos estresante."
  },
  {
    question: "¿Cuáles son los servicios funerarios que ofrecen?",
    answer: "En Columba te ofrecemos Velación en Casa, Velación en Sala y Servicio Directo, ya sea inhumación o cremación."
  },
  {
    question: "¿Qué incluye el set funerario básico?",
    answer: "♦	Trámites  ♦	Traslado de cuerpo ♦	Preservación del cuerpo  ♦	Ataúd  ♦	Carroza"
  },
  {
    question: "¿Los sets funerarios se pueden personalizar?",
    answer: "Sí, el servicio ya incluye un tipo de ataúd, pero puedes cambiarlo y elegir el que se adapte a tus necesidades, el tipo de carroza, las flores, los recuerdos, cafetería, alimentos o algún relicario."
  },
  {
    question: "¿Cuánto tiempo tarda en organizarse el servicio una vez contratado?",
    answer: "Una vez contratado el servicio la atención es inmediata, el tiempo puede variar por causas externas, por ejemplo, la liberación de un hospital o la distancia."
  },
  {
    question: "¿Apoyan en el traslado del cuerpo nacional e internacional?",
    answer: "Sí, contamos con experiencia funeraria para apoyar la repatriación del cuerpo o de otros estados. "
  },
  {
    question: "¿Qué hago si mi familiar ha fallecido y necesito el servicio de inmediato?",
    answer: "Ingresa a nuestra página https://columbafunerales.com/ y elige el tipo de servicio que deseas, llena los datos que se solicita, genera tu baucher de pago y confirma tu pedido en la llamada que recibirás. Listo, tu servicio está en camino. "
  }
];


const faqItems2 = [
  {
    question: "¿Pueden asesorarme durante el proceso?",
    answer: "Sí, estamos contigo en todo el proceso 24/7. Puedes marcar a nuestro número 722 917 3720 y recibirás una atención humana y personalizada."
  },
  {
    question: "¿Puedo ver los ataúdes y urnas disponibles en línea?",
    answer: "Sí, puedes visualizar los tipos de ataúd que ofrecemos para los servicios, así como las urnas disponibles."
  },
  {
    question: "¿Tienen flores, recordatorios u otros complementos?",
    answer: "Sí, ofrecemos un servicio completo con el objetivo de aportar comodidad, contención y hospitalidad sin que tengas que buscar en otro lado. "
  },
  {
    question: "¿Puedo solicitar factura?",
    answer: "Sí puedes solicitar la factura, presentando tu comprobante de pago y tus datos fiscales."
  },
  {
    question: "¿Puedo hablar con alguien por teléfono o chat para aclarar dudas?",
    answer: "Sí puedes contactarnos, estamos para acompañarte 24/7 y nuestro equipo te atenderá."
  },
  {
    question: "¿Puedo contratar un Plan a futuro?",
    answer: "Sí, contratar un Plan a futuro es un acto de amor para tus seres queridos. En Columba encontrarás el plan ideal para tus necesidades y las de tu familia."
  }
];


class PreguntasFrecuentes extends Component {
  state = {
    Error: '',
  }
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  componentDidMount() {
    this.scrollToTop();
  };
  render() {
    let theme = createTheme();


    const settings = {
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    };

    return (
      <Box className='ContenedorPF' >
        <Container className="PregutasFrecuentes">

          <Typography variant="h1" id='TituloPrincipal' >
            Preguntas frecuentes
          </Typography>
          <Box className="row mt-3">
            <Box className="col-sm-10">
              <Typography id='ParrafoPrincipal'>
                Aquí respondemos las preguntas habituales que recibimos de nuestros clientes. Sí tienes alguna otra, no dudes en contactarnos.
              </Typography>
            </Box>
          </Box>

          <Box id='PreguntasEscritorio'>
            <Box className='row mt-4 PreFrecuSeccion1'>
              <Box className='col-lg-6 ContenedorImagen mt-4'>
                <img src={ImagenPreguntaF2} alt="Pregunta frecuente 2" className="ImagenP" />
              </Box>
              <Box className='col-lg-6  mt-4'>
                <FAQ FaqItems={faqItems1} />
              </Box>
            </Box>

            <Box className='row PreFrecuSeccion2' mt='60px'>
              <Box className='col-lg-6 ContenedorImagen mt-4'>
                <img src={ImagenPreguntaF1} alt="Pregunta frecuente 2" className="ImagenP" />
              </Box>
              <Box className='col-lg-6 mt-4'>
                <FAQ FaqItems={faqItems2} />
              </Box>
            </Box>
          </Box>

          <Box id='PreguntasMovil'>
            <Box mt='60px'>
              <FAQ FaqItems={[...faqItems1, ...faqItems2]} FontSize={{ [theme.breakpoints.down(576)]: { fontSize: '16px' }, [theme.breakpoints.up(576)]: { fontSize: '18px' } }} />
            </Box>
            <Box mt={4}>
              <img src={ImagenPreguntaF2} alt="Pregunta frecuente 2" width='100%' />
            </Box>
          </Box>

          <Box className="hero-slider" id='slider_escritorio' mt='120px !important' mb='120px !important'  >
            <Slider  {...settings}>
              <Box className="slider-item" sx={{ backgroundImage: `url(${PreguntasAyuda})` }}>

                <Box className="container">
                  <Box className="row">
                    <Box className="col-lg-7" sx={{}}>
                      <Box className="content style text-left ContenedorInformacion" >
                        <Box sx={{ background: '#c44c24 !important', padding: '7px', opacity: '1', borderRadius: '5px', width: '152px' }} mb='30px'>
                          <Typography textAlign='left' fontSize='16px !important' color='white' className="itacaBlack" >Facilidad funeraria</Typography>
                        </Box>
                        <Typography variant="h2" mb='30px' data-animation-in="slideInLeft" sx={{ textAlign: 'left', opacity: '1', padding: '0px', color: 'rgb(255, 255, 255) !important', fontSize: '28px !important', borderRadius: '5px' }}>
                          Estamos para ayudarte.                        </Typography>

                        <Typography sx={{ fontSize: '18px !important', color: 'rgb(255, 255, 255) !important' }} textAlign='left' mb='30px'>
                          Respondemos todas tus dudas. Contáctanos, si tienes alguna pregunta específica o necesitas asistencia personalizada.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'start', width: '200px' }}>
                          <button onClick='' data-animation-in="slideInRight" type="button"
                            className="btn btn-block boton_amarillo">Contactar </button>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Slider>
          </Box>

          <Box id='slider_movil' mb='70px'>
            <Box className="content style text-left ContenedorInformacion" >
              <Box sx={{ background: '#c44c24', padding: '7px', opacity: '1', borderRadius: '5px', width: '152px' }}>
                <Typography textAlign='left' fontSize='16px !important' color='white' className="itacaBlack">Facilidad funeraria</Typography>
              </Box>
              <Typography variant="h2" data-animation-in="slideInLeft" className="SubituloInformacionMovil">
                Estamos para ayudarte.
              </Typography>

              <Typography className="ParrafoInformacionMovil">
                Hacemos todo lo posible por responder tus dudas, pero sabemos que cada caso es único. Si tienes una pregunta específica o necesitas asistencia personalizada.                
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'start', width: '200px' }}>
                <button onClick='' data-animation-in="slideInRight" type="button"
                  className="btn btn-block boton_amarillo">Contactar </button>
              </Box>
            </Box>

            <img alt="PreguntasAyudaMovil" src={PreguntasAyudaMovil} width='100%' />

          </Box>

        </Container>
      </Box>
    );
  }
}

export default PreguntasFrecuentes;

